import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import EditIcon from '@mui/icons-material/Edit';

function ContactDetails(props) {
  return (
    <Grid item xs={12} md={6}>
      <CardActionArea component="a" href="#">
        <Card sx={{ display: "flex" }}>
          <CardContent sx={{ flex: 1 }}>
            <Typography component="h2" variant="h5">
              Contact Details <EditIcon/>
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              E-Mail :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold" >
             {props.user.email}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Contact No :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold" >
             {props.user.phone}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
                Address :
            </Typography>
            <Typography variant="subtitle2" paragraph fontWeight="bold" >
                - 
            </Typography>
          </CardContent>
          <CardMedia
            component="img"
            sx={{ width: 160, display: { xs: "none", sm: "block" } }}
            image="https://source.unsplash.com/random/?blog/"
            alt="random"
          />
        </Card>
      </CardActionArea>
    </Grid>
  );
}

// FeaturedPost.propTypes = {
//   post: PropTypes.shape({
//     date: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     image: PropTypes.string.isRequired,
//     imageLabel: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//   }).isRequired,
// };

export default ContactDetails;
